import React from "react"

const MeetingContext = React.createContext()

export default MeetingContext
